import React,{useState} from 'react';
import {Card,Button} from '../../components';
import {connect} from 'react-redux';
import {FormatDate} from '../../Utils';
import {Redirect} from 'react-router-dom';

const MyTasks = ({tokenObject,connection}) => {

    const [Tasks,setTasks] = useState([]);
    const [Message,setMessage] = useState('');

    if(tokenObject.token === ""){
        return(
            <Redirect to="/login"/>
        );
    }

    async function GetTasks(){

        if(Tasks.length === 0){
            const result = await connection.get('/Tasks',
                {headers:{
                    'user-access-token':tokenObject.token
                }
            });

            const localTasks = [];

            result.data.forEach((value,index) => {
                localTasks.push(value);
            });

            setTasks(localTasks);
        }

    }

    if(Message !== ''){
        setTimeout(() => {
            setMessage('');
        },3000);
    }

    async function handleDeleteTask(event){

        const Id = event.target.id;

        const result = await connection.delete('/Tasks',
        {
            headers:{
                'user-access-token':tokenObject.token
            },
            data:{
                Id:Id
            }
        });

        if(result.data.n === 1){
            setTasks(Tasks.filter(
                (value) => {
                    return value._id != Id;
                }
            ));
            setMessage('Task removed sucessfully!');

        }else if(result.data.n === 0){
            setMessage('No task removed! You must be the creator of the task to remove it.');
        }
    }

    GetTasks();
    return(
        <>
        <br/>
        {(function(){
                return Message != '' ? (
                <div class="alert alert-warning" role="alert">
                    {Message}
                </div>) : (<></>)
                }
        )()}
        <Card>
            <br/>
                <center><h1>Tarefas</h1></center>
            <br/>
                {Tasks.map((value,index) => (
                        <Card key={index} title={value.Title}>
                            {value.Description}
                            <br/>
                            <br/>
                            <p>
                                <small className="text-muted">{FormatDate(value.Due_Date)}</small>
                            </p>
                            {(() => (<p>
                                        <Button type="danger" id = {value._id} onClick={handleDeleteTask}>Remove Task</Button>
                                    </p>))()}
                        </Card>
                ))}
        </Card>
        </>
        
    );
}

const mapStateToProps = (state) => ({
    tokenObject: state.token
});

export default connect(mapStateToProps)(MyTasks);